'use client'

import { useEffect, useState } from 'react'
import { useCatchScroll } from '@/utils/useCatchScroll'
import { Icon } from '../Icon'
import { Typography } from '../Typography'
import styles from './ScrollToTop.module.scss'

const SCROLL_SHOW_OFFSET = 500
const AUTO_HIDE_DELAY = 5000

const ScrollToTop = () => {
  const [showGoTop, setShowGoTop] = useState(false)
  const { scrollDir } = useCatchScroll()

  useEffect(() => {
    if (typeof globalThis === 'undefined') return

    const handleVisibleButton = () => {
      setShowGoTop((globalThis.scrollY ?? 0) > SCROLL_SHOW_OFFSET)
    }

    globalThis.addEventListener('scroll', handleVisibleButton, {
      passive: true,
    })

    return () => {
      globalThis.removeEventListener('scroll', handleVisibleButton)
    }
  }, [])

  useEffect(() => {
    if (!showGoTop) return

    const timer = globalThis.setTimeout(() => {
      setShowGoTop(false)
    }, AUTO_HIDE_DELAY)

    return () => {
      globalThis.clearTimeout(timer)
    }
  }, [showGoTop])

  const handleScrollUp = () => {
    if (typeof globalThis === 'undefined') return

    globalThis.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      type="button"
      className={showGoTop && scrollDir === 'scrolling up' ? styles['scroll-top'] : styles.hidden}
      onClick={handleScrollUp}
    >
      <Icon name="arrowUp" />
      <Typography as="span" variant="s">
        nach oben
      </Typography>
    </button>
  )
}

export default ScrollToTop
